import React from "react";

const IntroSection = () => {
    return (
        <section className="section-intro">
            <div>
                <h1>Start trading instantly</h1>
            </div>
        </section>
    );
}

export default IntroSection;